import { SelectProps } from 'antd';
import Select, { DefaultOptionType } from 'antd/es/select';
import React from 'react';

type SelectPropsWithRef = SelectProps & React.RefAttributes<any>;
interface ISearchableSelectProps extends SelectPropsWithRef {}

// This component is responsible for making all select boxes have search feature
const SearchableSelect: React.FC<ISearchableSelectProps> = (props) => {
  const filterOption = (inputValue: string, option: DefaultOptionType | undefined) => {
    if (!option || !option.label) return false;
    const { label } = option;
    if (typeof label === 'string') {
      return (option.label as string).toLowerCase().includes(inputValue.toLowerCase());
    }
    if (typeof label === 'number') {
      return option.label === Number(inputValue);
    }
    return false;
  };

  return <Select showSearch filterOption={filterOption} {...props} />;
};

export default SearchableSelect;
